var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 82,
    viewBox: "0 0 79 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 40.126,
    r: 39.5,
    fill: "#E4F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 47.2511L38.4825 64.1052C38.785 64.3286 39.1425 64.4386 39.5 64.4386C39.8575 64.4386 40.215 64.3286 40.5175 64.1052L67 47.2511L40.5312 26.9698C39.9194 26.5127 39.0806 26.5127 38.4688 26.9698L12 47.2511Z",
    fill: "#36AADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6875 26.626H22.3125C20.4184 26.626 18.875 28.1694 18.875 30.0635V67.876C18.875 68.8247 19.645 69.5947 20.5938 69.5947H58.4062C59.355 69.5947 60.125 68.8247 60.125 67.876V30.0635C60.125 28.1694 58.585 26.626 56.6875 26.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4688 36.9385H51.5312C52.48 36.9385 53.25 36.1685 53.25 35.2197C53.25 34.271 52.48 33.501 51.5312 33.501H27.4688C26.52 33.501 25.75 34.271 25.75 35.2197C25.75 36.1685 26.52 36.9385 27.4688 36.9385Z",
    fill: "#2EC4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5312 40.376H27.4688C26.52 40.376 25.75 41.146 25.75 42.0947C25.75 43.0435 26.52 43.8135 27.4688 43.8135H51.5312C52.48 43.8135 53.25 43.0435 53.25 42.0947C53.25 41.146 52.48 40.376 51.5312 40.376Z",
    fill: "#2EC4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2188 47.251H27.4688C26.52 47.251 25.75 48.021 25.75 48.9697C25.75 49.9185 26.52 50.6885 27.4688 50.6885H41.2188C42.1675 50.6885 42.9375 49.9185 42.9375 48.9697C42.9375 48.021 42.1675 47.251 41.2188 47.251Z",
    fill: "#2EC4BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5175 64.105C40.215 64.3285 39.8575 64.4385 39.5 64.4385C39.1425 64.4385 38.785 64.3285 38.4825 64.105L12 47.251V78.1885C12 80.086 13.54 81.626 15.4375 81.626H63.5625C65.46 81.626 67 80.086 67 78.1885V47.251L40.5175 64.105Z",
    fill: "#0E94CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5625 81.626H15.4375C13.5091 81.626 12 80.1169 12 78.1885C12 77.6419 12.2612 77.1263 12.7012 76.8032L38.4825 59.6157C38.785 59.3922 39.1425 59.2822 39.5 59.2822C39.8575 59.2822 40.215 59.3922 40.5175 59.6157L66.2987 76.8032C66.7387 77.1263 67 77.6419 67 78.1885C67 80.1169 65.4909 81.626 63.5625 81.626Z",
    fill: "#2CA7DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(12 26.626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.8f3e4789853a830d5864f8cceaa75837.svg";
export { ForwardRef as ReactComponent };